const watch = require('redux-watch');
export { watch };
